import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'moment/locale/pt-br'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import NumberFormat from 'react-number-format';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import cadastrarItinerario from '../../actions/itinerario/cadastrarItinerario'
import alterarItinerario from '../../actions/itinerario/alterarItinerario'
import { ativarItinerario, inativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import { BotaoAtivarOuInativar } from './BotaoAtivarOuInativar';
import {
    renderFieldNumerosPorcentagem,
    renderFieldSelect,
    required,
    requiredSelect,
    tamanhoHoraMinuto,
    tamanhoPorcentagem,
    validateHora,
    validateMinutos
} from '../../util/inputs';
import Select from 'react-select';
import { showAlertMsg, showSuccessMsg } from '../../util/messagesUtil';
import BloqueioDescontoItinerario from './BloqueioDescontoItinerario';
import { tipoCategoria, tiposConfiguracoesPreco, tiposConfiguracoesPrecoPrioritario, tiposConfiguracoesPrecoCategoria } from '../../util/constantsUtil';
import MapaVeiculoCategoriaPoltrona from './MapaVeiculoCategoriaPoltrona';
import selecionarVeiculoItinerario from '../../actions/itinerario/selecionarVeiculoItinerario';
import ModalConfiguracaoCategoriaPoltrona from './ModalConfiguracaoCategoriaPoltrona';
import limparVeiculoItinerarioSelecionado from '../../actions/itinerario/limparVeiculoItinerarioSelecionado';
import FieldsetBloquearVendedores from './FieldsetBloquearVendedores';
import FieldsetConfiguracaoPreco from './FieldsetConfiguracaoPreco';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

const renderToggle = ({ input }) => (
    <label className="vx-switch" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input {...input} type="checkbox" />
        <span className="vx-switch-slider" />
    </label>
);

const renderFieldHora = ({
    input,
    label,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>{label}</label>
        <NumberFormat {...input} format="##:##"
            className={css}
            maxLength={max}
            style={{ borderColor: touched && error ? 'red' : '' }}
            readOnly={readOnly}
        />
        {touched && error && <span style={{ color: 'red', fontSize: 11, display: 'block', marginTop: 2 }}>{error}</span>}
    </div>
);

const SELECT_STYLES = {
    control: base => ({ ...base, fontSize: 13, minHeight: 36, borderColor: '#e4e7ea', cursor: 'pointer' }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
};

export class ModalCadastrarItinerario extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.componentRef = React.createRef();
        this.limparFormulario = this.limparFormulario.bind(this);
        this.fecharModal = this.fecharModal.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.props.changeFieldValue('formularioCadastroItinerario', 'habilitadoSite',
            this.props.empresaSelecionada.habilitadoSite);
        this.props.changeFieldValue('formularioCadastroItinerario', 'criarInativo', false);
        this.props.changeFieldValue('formularioCadastroItinerario', 'horarioExtra', false);
        this.state = {
            habilitaConfiguracaoCategoriaPoltrona: false,
            listaCategoriasPoltronas: [],
            tipoPrecoPrimeiroAndarPadrao: null,
            tipoPrecoSegundoAndarPadrao: null,
            andarSelecionado: this.props.itinerarioSelecionado.andar || 1,
        };
    }

    onChangeDate = (date) => {
        this.props.changeFieldValue('formularioCadastroItinerario', 'dataPartida', date);
    };

    handleExibirCamposAjusteValor(evento) {
        if (evento.target.value) {
            this.props.changeFieldValue('formularioCadastroItinerario', 'valorAjuste', '');
            this.props.changeFieldValue('formularioCadastroItinerario', 'tipoAjusteItinerario', '');
        }
        this.props.changeFieldValue('formularioCadastroItinerario', 'exibirAjuste', evento.target.value);
    }

    handleExibirCamposAjusteValorPrioritario(evento) {
        if (evento.target.value) {
            this.props.changeFieldValue('formularioCadastroItinerario', 'exibirAjustePrioritario', '');
            this.props.changeFieldValue('formularioCadastroItinerario', 'tipoAjusteItinerarioPrioritario', '');
        }
        this.props.changeFieldValue('formularioCadastroItinerario', 'exibirAjustePrioritario', evento.target.value);
    }

    montarParametroItinerario(values) {
        let tipoAjuste = null;
        let valorAjuste = null;
        let tipoPrecoSegundoAndar = null;
        let tipoConfiguracaoPreco = null;
        let horaPartidaRegra = null;
        let quantidadePoltronasRegra = null;
        let tipoConfiguracaoPrecoPrioritario = null;

        if (values.exibirAjuste) {
            tipoAjuste = values.tipoAjusteItinerario ? values.tipoAjusteItinerario.value : null;
            tipoConfiguracaoPreco = values.tipoConfiguracaoPreco ? values.tipoConfiguracaoPreco.value : null;
            valorAjuste = values.valorAjuste ? values.valorAjuste.replace('R$', '') : '0';
            if (tipoConfiguracaoPreco === 'DATA_PARTIDA') {
                horaPartidaRegra = values.horaPartidaRegra;
            }
            if (tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_CADA' ||
                tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_PARTIR' ||
                tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_ATE_NUMERO') {
                quantidadePoltronasRegra = values.quantidadePoltronasRegra;
            }
        }
        if (values.exibirAjustePorCategoria) {
            tipoConfiguracaoPrecoPrioritario = 'POR_CATEGORIA';
        } else {
            this.props.limparPricePorCategoria();
        }
        if (values.exibirAjustePrioritario) {
            tipoConfiguracaoPrecoPrioritario = values.tipoConfiguracaoPrecoPrioritario ? values.tipoConfiguracaoPrecoPrioritario.value : 'POR_USUARIO';
        } else {
            this.props.limparPricePorUsuario();
        }
        if (!this.props.idItinerario && this.props.veiculo.value.seDoisAndares) {
            tipoPrecoSegundoAndar = this.props.exibeTipoCategoriaUnica ? values.tipoPrecoSegundoAndar.value : null;
        }
        return {
            id: values.idItinerario,
            descontoMaximo: values.descontoMaximo ? values.descontoMaximo.replace('R$', '') : '0.00',
            dataPartida: values.dataPartida,
            horaSaida: values.horaSaida,
            habilitadoSite: values.habilitadoSite ? values.habilitadoSite : false,
            idVeiculo: values.veiculo.value.id,
            idsUsuariosEmpresaMotorista: this.props.motoristasSelecionados ? this.props.motoristasSelecionados.map(it => it.value) : null,
            idsUsuariosEmpresaBloqueio: this.props.usuarioEmpresaBloqueioSelecionados ? this.props.usuarioEmpresaBloqueioSelecionados.map(it => it.value) : null,
            idEmpresa: this.props.empresaSelecionada.id,
            idRota: this.props.rotaSelecionada.value,
            trechosBloqueados: this.props.trechosSelecionados.map(it => (
                { idTrechoOrigem: it.origem.value, idTrechoDestino: it.destino.value }
            )),
            cidadeBloqueadas: this.props.cidadesSelecionadas.map(it => (
                { idCidade: it.value }
            )),
            trechosBloqueadosDesconto: this.props.trechosBloqueioDescontoSelecionados.map(it => (
                { idTrechoOrigem: it.origem.value, idTrechoDestino: it.destino.value }
            )),
            valorAjuste,
            tipoAjuste,
            tipoPrecoPrimeiroAndar: this.props.exibeTipoCategoriaUnica ? values.tipoPrecoPrimeiroAndar.value : null,
            tipoPrecoSegundoAndar,
            tipoConfiguracaoPreco,
            horaPartidaRegra,
            quantidadePoltronasRegra,
            idPrestador: values.prestador ? values.prestador.value : null,
            tipoCategoria: this.props.exibeTipoCategoriaUnica ? tipoCategoria.unica.valor : tipoCategoria.mista.valor,
            tipoPrecoPrimeiroAndarPadrao: this.state.tipoPrecoPrimeiroAndarPadrao,
            tipoPrecoSegundoAndarPadrao: this.state.tipoPrecoSegundoAndarPadrao,
            listaCategoriasPoltronas: !this.props.exibeTipoCategoriaUnica ? this.state.listaCategoriasPoltronas.map(it => ({
                numeroAssento: it.assento.numero,
                tipoPreco: it.tipoPreco,
                andar: it.andar
            })) : null,
            tipoConfiguracaoPrecoPrioritario,
            pricePorUsuarioEmpresa: values.exibirAjustePrioritario ? this.props.vendedoresSelecionados.map(it => ({
                tipoAjuste: it.tipoAjusteItinerario.value,
                valorAjuste: it.valorAjuste,
                tipoConifguracaoPreco: it.tipoConfiguracaoPreco ? it.tipoConfiguracaoPreco.value : 'POR_USUARIO',
                usuarioId: it.id,
            })) : [],
            pricePorCategoria: values.exibirAjustePorCategoria ? this.props.categoriasSelecionadas.map(it => ({
                tipoPreco: it.tipoPreco,
                tipoAjuste: it.tipoAjusteItinerario.value,
                valorAjuste: it.valorAjuste,
            })) : [],
            criarInativo: values.criarInativo ? values.criarInativo : false,
            horarioExtra: values.horarioExtra ? values.horarioExtra : false,
        };
    }

    fecharModal() {
        $('#modalCadastrarItinerario').modal('hide');
        $('#modalCadastrarItinerario').hide();
        $('.modal-backdrop').hide();
        this.limparFormulario();
    }

    handleChecked() {
        this.props.handleCheckedTipoCategoriaUnica();
    }

    submit(values) {
        const parametros = this.montarParametroItinerario(values);
        if (this.props.idItinerario) {
            this.props.alterarItinerario(parametros).then(() => {
                showSuccessMsg('Itinerário alterado com sucesso');
                this.fecharModal();
                this.props.buscarItinerarios();
            });
        } else {
            this.props.cadastrarItinerario(parametros).then(() => {
                showSuccessMsg('Itinerário cadastrado com sucesso');
                this.fecharModal();
                this.props.buscarItinerarios();
            });
        }
    }

    limparFormulario() {
        this.props.reset('formularioCadastroItinerario');
        this.props.limparMotoristasSelecionados();
        this.props.limparUsuarioEmpresaBloqueioSelecionados();
        this.props.limparTrechosSelecionados();
        this.props.limparCidadesSelecionadas();
        this.props.limparPricePorUsuario();
        this.props.limparPricePorCategoria();
        this.props.handleCheckedTipoCategoriaUnica(true);
        this.verificarAndarSelecionado(1);
        this.props.limparVeiculoItinerarioSelecionado();
        this.setState({ habilitaConfiguracaoCategoriaPoltrona: true });
        this.props.changeFieldValue('formularioCadastroItinerario', 'habilitadoSite',
            this.props.empresaSelecionada.habilitadoSite);
        this.props.changeFieldValue('formularioCadastroItinerario', 'criarInativo', false);
        this.props.changeFieldValue('formularioCadastroItinerario', 'horarioExtra', false);
    }

    exibirComboTipoPreco(name, label) {
        return (
            <div>
                <Field name={name}
                    options={this.props.tiposPreco.filter(it => it.tipoPreco != 'TODAS' ).map(elemento => ({
                        descricao: elemento.descricaoTipoPreco,
                        nome: elemento.tipoPreco
                    }))}
                    component={renderFieldSelect}
                    label={label}
                    placeholder='Selecione a categoria'
                    validate={requiredSelect}
                    menuPortalTarget={document.body}
                />
            </div>
        );
    }

    exibirCalendario(event) {
        return (
            <div>
                <DatePicker
                    className='form-control'
                    selected={this.props.dataPartida}
                    locale="pt-BR"
                    onChange={date => this.onChangeDate(date)}
                    placeholder={`${this.props.dataPartida}`}
                    dateFormat="dd/MM/yyyy"
                    withPortal
                />
                {event.meta.touched && event.meta.error && (
                    <span style={{ color: 'red', fontSize: 11 }}>{event.meta.error}</span>
                )}
            </div>
        );
    }

    handleSelecionarMotorista(evento) {
        this.props.selecionarMotorista(evento);
    }

    handleSelecionarVeiculo(evento) {
        this.verificarAndarSelecionado(1);
        this.props.selecionarVeiculoItinerario(evento);
    }

    adicionarCidade(event) {
        event.preventDefault();
        this.props.adicionarCidades(this.props.cidade);
        this.props.changeFieldValue('formularioCadastroItinerario', 'cidade', null);
    }

    adicionarTrechos(event) {
        event.preventDefault();
        this.props.adicionarTrechos(this.props.trechoOrigem, this.props.trechoDestino);
        this.props.changeFieldValue('formularioCadastroItinerario', 'trechoOrigem', null);
        this.props.changeFieldValue('formularioCadastroItinerario', 'trechoDestino', null);
    }

    adicionarPricePorUsuario(event) {
        event.preventDefault();
        if (!this.props.valorAjustePrioritario) { showAlertMsg('Informe o valor.'); return; }
        if (!this.props.tipoAjusteItinerarioPrioritario) { showAlertMsg('Informe o desconto/acréscimo.'); return; }
        if (!this.props.vendedores) { showAlertMsg('Informe o usuário.'); return; }
        const obj = {
            id: this.props.vendedores.value,
            vendedor: this.props.vendedores,
            valorAjuste: this.props.valorAjustePrioritario,
            tipoAjusteItinerario: this.props.tipoAjusteItinerarioPrioritario,
            tipoConfiguracaoPreco: this.props.tipoConfiguracaoPrecoPrioritario,
        };
        this.props.adicionarPricePorUsuario(obj);
        this.props.changeFieldValue('formularioCadastroItinerario', 'vendedores', null);
    }

    adicionarPricePorCategoria(event) {
        event.preventDefault();
        if (!this.props.valorAjusteCategoria) { showAlertMsg('Informe o valor.'); return; }
        if (!this.props.tipoAjusteCategoria) { showAlertMsg('Informe o desconto/acréscimo.'); return; }
        if (!this.props.tipoPrecoCategoria) { showAlertMsg('Informe o tipo de serviço.'); return; }
        const obj = {
            tipoPreco: this.props.tipoPrecoCategoria.value,
            descricao: this.props.tipoPrecoCategoria.label,
            valorAjuste: this.props.valorAjusteCategoria,
            tipoAjusteItinerario: this.props.tipoAjusteCategoria,
        };
        this.props.adicionarPricePorCategoria(obj);
        this.props.changeFieldValue('formularioCadastroItinerario', 'tipoPrecoCategoria', null);
    }

    recuperarTrechos() {
        const { rotas, rotaSelecionada, trechos } = this.props;
        if (!rotas || !rotaSelecionada || !trechos) return [];
        return [...trechos].sort((n1, n2) => {
            if (n1.ordem > n2.ordem) return 1;
            if (n1.ordem < n2.ordem) return -1;
            return 0;
        });
    }

    preencherListaCategoriasPoltronas(lista) {
        this.setState({ listaCategoriasPoltronas: lista });
    }

    preencherTipoPrechoPrimeiroAndarPadrao(tipo) {
        this.setState({ tipoPrecoPrimeiroAndarPadrao: tipo });
    }

    preencherTipoPrechoSegundoAndarPadrao(tipo) {
        this.setState({ tipoPrecoSegundoAndarPadrao: tipo });
    }

    verificarAndarSelecionado(andarSelecionado) {
        this.setState({ andarSelecionado });
    }

    obterTiposPrecoDoMapa() {
        const { tiposPreco, idItinerario, itinerarioSelecionado } = this.props;
        if (!tiposPreco) return [];
        let tiposNoMapa = [];
        if (idItinerario && itinerarioSelecionado && itinerarioSelecionado.poltronas) {
            tiposNoMapa = [...new Set(itinerarioSelecionado.poltronas.map(p => p.tipoPreco))];
        } else {
            const { listaCategoriasPoltronas, tipoPrecoPrimeiroAndarPadrao, tipoPrecoSegundoAndarPadrao } = this.state;
            const tipos = listaCategoriasPoltronas.map(it => it.tipoPreco);
            if (tipoPrecoPrimeiroAndarPadrao) tipos.push(tipoPrecoPrimeiroAndarPadrao);
            if (tipoPrecoSegundoAndarPadrao) tipos.push(tipoPrecoSegundoAndarPadrao);
            tiposNoMapa = [...new Set(tipos)];
        }
        return tiposPreco.filter(tp => tiposNoMapa.includes(tp.tipoPreco));
    }

    desabilitarBotaoSalvar() {
        if (this.props.exibeTipoCategoriaUnica) return false;
        if (!this.props.idItinerario && !this.state.habilitaConfiguracaoCategoriaPoltrona) return true;
        if (!this.props.exibeTipoCategoriaUnica) {
            if (!this.idItinerario && this.props.veiculoItinerarioSelecionado.value.seDoisAndares) {
                return this.state.tipoPrecoPrimeiroAndarPadrao == null || this.state.tipoPrecoSegundoAndarPadrao == null;
            } else if (this.state.andarSelecionado == 1) {
                return this.state.tipoPrecoPrimeiroAndarPadrao == null;
            } else if (this.state.andarSelecionado == 2) {
                return this.state.tipoPrecoSegundoAndarPadrao == null;
            }
        }
        return false;
    }

    criarInativo(e) {
        if (e.target.checked) {
            this.props.changeFieldValue('formularioCadastroItinerario', 'criarInativo', false);
        }
    }

    render() {
        const { handleSubmit, submitting, invalid, pristine } = this.props;
        const trechos = this.recuperarTrechos();
        const temDoisAndares = !this.props.idItinerario && this.props.veiculo && this.props.veiculo.value && this.props.veiculo.value.seDoisAndares;

        return (
            <div className="modal fade show" id='modalCadastrarItinerario' role='dialog'
                aria-labelledby='modalCadastrarItinerario' aria-hidden='true' data-backdrop='static'>
                <div className='modal-dialog modal-dialog-centered modal-xl'>
                    <div className="modal-content vx-modal-content">

                        {/* ── Header ── */}
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">event</i>
                                <span className="vx-modal-title">
                                    {this.props.idItinerario ? 'Editar Itinerário' : 'Novo Itinerário'}
                                </span>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>

                        {/* ── Body ── */}
                        <div className="vx-modal-body">
                            <form id="form-cadastrar-itinerario" onSubmit={handleSubmit(this.submit)}>

                                {/* 1. Informações Básicas */}
                                <SectionCard icon="event" title="Informações Básicas" subtitle="Data, horário, veículo e configuração geral">
                                    <div className="vx-itin-basics-grid">
                                        <div>
                                            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Data de Partida</label>
                                            <Field name="dataPartida" type="texto"
                                                component={this.exibirCalendario.bind(this)}
                                                css="form-control" readOnly={false} />
                                        </div>
                                        <div>
                                            <Field name="horaSaida" type="texto" component={renderFieldHora}
                                                label="Hora de Partida"
                                                css="form-control" readOnly={false}
                                                validate={[required, validateMinutos, validateHora, tamanhoHoraMinuto]} />
                                        </div>
                                        <div>
                                            <Field name='veiculo'
                                                options={this.props.veiculos.map(elemento => ({
                                                    descricao: elemento.descricao,
                                                    nome: elemento
                                                }))}
                                                component={renderFieldSelect}
                                                label="Veículo"
                                                placeholder='Selecione um veículo'
                                                validate={requiredSelect}
                                                disabled={this.props.idItinerario}
                                                onChange={(e) => this.handleSelecionarVeiculo(e)}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                        <div>
                                            <Field name='prestador'
                                                options={this.props.prestadoresSimples.map(elemento => ({
                                                    descricao: elemento.valor,
                                                    nome: elemento.chave
                                                }))}
                                                component={renderFieldSelect}
                                                label="Prestador"
                                                placeholder='Selecione um prestador'
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                    </div>

                                    <div className="vx-toggle-row">
                                        <div className="vx-toggle-info">
                                            <div className="vx-toggle-info-title">Criar Inativo</div>
                                            <div className="vx-toggle-info-desc">O itinerário será criado sem ativação imediata</div>
                                        </div>
                                        <Field name='criarInativo' type="checkbox" component={renderToggle}
                                            onChange={(e) => this.criarInativo(e)} />
                                    </div>

                                    {this.props.empresaSelecionada.habilitadoSite && (
                                        <div className="vx-toggle-row">
                                            <div className="vx-toggle-info">
                                                <div className="vx-toggle-info-title">Vender no Site</div>
                                                <div className="vx-toggle-info-desc">Habilita este itinerário para venda online</div>
                                            </div>
                                            <Field name='habilitadoSite' type="checkbox" component={renderToggle} />
                                        </div>
                                    )}

                                    <div className="vx-toggle-row">
                                        <div className="vx-toggle-info">
                                            <div className="vx-toggle-info-title">Horário Extra</div>
                                            <div className="vx-toggle-info-desc">Marque se este itinerário é um horário extra</div>
                                        </div>
                                        <Field name='horarioExtra' type="checkbox" component={renderToggle} />
                                    </div>

                                    <div style={{ marginTop: 16 }}>
                                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 8 }}>Tipo de Categoria</label>
                                        <div className="vx-radio-cards">
                                            {[
                                                { val: true, label: tipoCategoria.unica.descricao, desc: 'Uma categoria para todos os assentos' },
                                                { val: false, label: tipoCategoria.mista.descricao, desc: 'Categorias diferentes por assento' },
                                            ].map(({ val, label, desc }) => {
                                                const selected = val ? this.props.exibeTipoCategoriaUnica : !this.props.exibeTipoCategoriaUnica;
                                                return (
                                                    <div key={String(val)}
                                                        className={`vx-radio-card${selected ? ' vx-radio-card--selected' : ''}`}
                                                        onClick={() => { if (!selected) this.handleChecked(); }}>
                                                        <div className="vx-radio-card-title">
                                                            <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle', marginRight: 5, color: selected ? 'var(--vx-primary)' : '#ccc' }}>
                                                                {selected ? 'radio_button_checked' : 'radio_button_unchecked'}
                                                            </i>
                                                            {label}
                                                        </div>
                                                        <div className="vx-radio-card-desc">{desc}</div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </SectionCard>

                                {/* 2. Configuração de Categoria (condicional – categoria única) */}
                                {this.props.exibeTipoCategoriaUnica && (
                                    <SectionCard icon="category" title="Configuração de Categoria" subtitle="Tipo de serviço para os assentos do veículo">
                                        <div style={{ display: 'grid', gridTemplateColumns: temDoisAndares ? '1fr 1fr' : '1fr 2fr', gap: 16 }}>
                                            {this.exibirComboTipoPreco('tipoPrecoPrimeiroAndar', temDoisAndares ? 'Categoria 1° Andar' : 'Categoria')}
                                            {temDoisAndares
                                                ? this.exibirComboTipoPreco('tipoPrecoSegundoAndar', 'Categoria 2° Andar')
                                                : <div />}
                                        </div>
                                    </SectionCard>
                                )}

                                {/* 3. Configuração por Poltrona (condicional – categoria mista) */}
                                {!this.props.exibeTipoCategoriaUnica && (
                                    <SectionCard icon="event_seat" title="Configuração por Poltrona" subtitle="Defina a categoria individualmente para cada assento">
                                        {this.props.veiculo ? (
                                            <div>
                                                {!this.props.idItinerario && !this.state.habilitaConfiguracaoCategoriaPoltrona && (
                                                    <button className="vx-btn-primary" style={{ marginBottom: 12 }}
                                                        onClick={(e) => { e.preventDefault(); this.setState({ habilitaConfiguracaoCategoriaPoltrona: true }); }}>
                                                        <i className="material-icons" style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }}>edit</i>
                                                        Editar Configuração
                                                    </button>
                                                )}
                                                {this.state.habilitaConfiguracaoCategoriaPoltrona || this.props.idItinerario
                                                    ? <ModalConfiguracaoCategoriaPoltrona
                                                        idItinerario={this.props.idItinerario}
                                                        exibeTipoCategoriaUnica={this.props.exibeTipoCategoriaUnica}
                                                        preencherListaCategoriasPoltronas={this.preencherListaCategoriasPoltronas.bind(this)}
                                                        preencherTipoPrechoPrimeiroAndarPadrao={this.preencherTipoPrechoPrimeiroAndarPadrao.bind(this)}
                                                        preencherTipoPrechoSegundoAndarPadrao={this.preencherTipoPrechoSegundoAndarPadrao.bind(this)}
                                                        andarSelecionado={this.state.andarSelecionado}
                                                        verificarAndarSelecionado={this.verificarAndarSelecionado.bind(this)} />
                                                    : <MapaVeiculoCategoriaPoltrona
                                                        idItinerario={this.props.idItinerario}
                                                        andarSelecionado={this.state.andarSelecionado}
                                                        verificarAndarSelecionado={this.verificarAndarSelecionado.bind(this)} />
                                                }
                                            </div>
                                        ) : (
                                            <p style={{ color: '#FF6A00', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, margin: 0 }}>
                                                <i className="material-icons" style={{ fontSize: 16 }}>info</i>
                                                Selecione um veículo para configurar as categorias por poltrona.
                                            </p>
                                        )}
                                    </SectionCard>
                                )}

                                {/* 4. Configuração de Preço */}
                                <FieldsetConfiguracaoPreco
                                    exibirAjuste={this.props.exibirAjuste}
                                    exibirAjustePrioritario={this.props.exibirAjustePrioritario}
                                    exibirAjustePorCategoria={this.props.exibirAjustePorCategoria}
                                    exibeTipoCategoriaUnica={this.props.exibeTipoCategoriaUnica}
                                    tipoConfiguracaoPreco={this.props.tipoConfiguracaoPreco}
                                    quantidadePoltronasRegra={this.props.quantidadePoltronasRegra}
                                    tipoConfiguracaoPrecoPrioritario={this.props.tipoConfiguracaoPrecoPrioritario}
                                    quantidadePoltronasRegraPrioritario={this.props.quantidadePoltronasRegraPrioritario}
                                    tiposConfiguracoesPreco={tiposConfiguracoesPreco}
                                    tiposConfiguracoesPrecoPrioritario={tiposConfiguracoesPrecoPrioritario}
                                    tiposConfiguracoesPrecoCategoria={tiposConfiguracoesPrecoCategoria}
                                    usuariosVendedores={this.props.usuariosVendedores}
                                    vendedoresSelecionados={this.props.vendedoresSelecionados}
                                    tiposPreco={this.obterTiposPrecoDoMapa()}
                                    categoriasSelecionadas={this.props.categoriasSelecionadas}
                                    onToggleAjuste={e => this.handleExibirCamposAjusteValor(e)}
                                    onToggleAjustePrioritario={e => this.handleExibirCamposAjusteValorPrioritario(e)}
                                    onToggleAjustePorCategoria={e => this.props.changeFieldValue('formularioCadastroItinerario', 'exibirAjustePorCategoria', e.target.value)}
                                    onAdicionarPricePorUsuario={e => this.adicionarPricePorUsuario(e)}
                                    onRemoverUsuarioVendedor={id => this.props.removerUsuarioVendedor(id)}
                                    onAdicionarPricePorCategoria={e => this.adicionarPricePorCategoria(e)}
                                    onRemoverCategoriaSelecionada={tipoPreco => this.props.removerCategoriaSelecionada(tipoPreco)}
                                />

                                {/* 5. Desconto Máximo */}
                                <SectionCard icon="local_offer" title="Desconto Máximo" subtitle="Limite de desconto aplicável neste itinerário">
                                    <div style={{ maxWidth: 260 }}>
                                        <Field name='descontoMaximo' validate={[tamanhoPorcentagem]}
                                            component={renderFieldNumerosPorcentagem}
                                            css="form-control" label="Desconto máximo(%):" />
                                    </div>
                                </SectionCard>

                                {/* 6. Bloqueio de Desconto por Trecho (condicional) */}
                                {this.props.exibirAjuste && (
                                    <BloqueioDescontoItinerario
                                        trechoDestinoBloqueioDesconto={this.props.trechoDestinoBloqueioDesconto}
                                        changeFieldValue={this.props.changeFieldValue}
                                        trechoOrigemBloqueioDesconto={this.props.trechoOrigemBloqueioDesconto}
                                        trechosBloqueioDescontoSelecionados={this.props.trechosBloqueioDescontoSelecionados}
                                        adicionarTrechosBloqueioDesconto={this.props.adicionarTrechosBloqueioDesconto}
                                        removerTrechoBloqueioDescontoSelecionado={this.props.removerTrechoBloqueioDescontoSelecionado}
                                        rotaSelecionada={this.props.rotaSelecionada}
                                        rotas={this.props.rotas}
                                        trechos={trechos}
                                    />
                                )}

                                {/* 7. Bloqueios de Venda */}
                                <div className="vx-config-grid">
                                    <SectionCard icon="block" title="Bloqueio por Trechos" subtitle="Impeça vendas em trechos específicos da rota">
                                        <div className="vx-add-row vx-add-row-2">
                                            <Field name='trechoOrigem'
                                                options={trechos.map(elemento => ({
                                                    descricao: elemento.cidadeDestino.nome,
                                                    nome: elemento.id
                                                }))}
                                                component={renderFieldSelect}
                                                placeholder='Trecho de origem'
                                                menuPortalTarget={document.body}
                                            />
                                            <Field name='trechoDestino'
                                                options={trechos.map(elemento => ({
                                                    descricao: elemento.cidadeDestino.nome,
                                                    nome: elemento.id
                                                }))}
                                                component={renderFieldSelect}
                                                placeholder='Trecho de destino'
                                                menuPortalTarget={document.body}
                                            />
                                            <button
                                                disabled={!this.props.trechoOrigem || !this.props.trechoDestino}
                                                type="button"
                                                className="vx-btn-incluir"
                                                onClick={(e) => this.adicionarTrechos(e)}>
                                                <i className="material-icons" style={{ fontSize: 14 }}>add</i> Incluir
                                            </button>
                                        </div>
                                        <div className="vx-item-list">
                                            {!this.props.trechosSelecionados || this.props.trechosSelecionados.length === 0
                                                ? <div className="vx-item-list-empty">Nenhum trecho bloqueado</div>
                                                : this.props.trechosSelecionados.map((t, i) => (
                                                    <div key={i} className="vx-item-list-item">
                                                        <div className="vx-item-list-item-info">
                                                            <span className="vx-item-list-item-label">{t.origem.label}</span>
                                                            <i className="material-icons" style={{ fontSize: 14, color: '#aaa' }}>arrow_forward</i>
                                                            <span className="vx-item-list-item-label">{t.destino.label}</span>
                                                        </div>
                                                        <button type="button" className="vx-item-list-remove"
                                                            onClick={() => this.props.removerTrechoSelecionado(t.origem.value, t.destino.value)}>
                                                            <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                                                        </button>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </SectionCard>

                                    <SectionCard icon="location_off" title="Bloqueio por Cidades" subtitle="Impeça vendas em cidades específicas">
                                        <div className="vx-add-row vx-add-row-1">
                                            <Field name="cidade"
                                                options={trechos.map(elemento => ({
                                                    descricao: elemento.cidadeDestino.nome,
                                                    nome: elemento.cidadeDestino.id
                                                }))}
                                                component={renderFieldSelect}
                                                placeholder='Selecione a cidade'
                                                menuPortalTarget={document.body}
                                            />
                                            <button disabled={!this.props.cidade}
                                                type="button"
                                                className="vx-btn-incluir"
                                                onClick={(e) => this.adicionarCidade(e)}>
                                                <i className="material-icons" style={{ fontSize: 14 }}>add</i> Incluir
                                            </button>
                                        </div>
                                        <div className="vx-item-list">
                                            {!this.props.cidadesSelecionadas || this.props.cidadesSelecionadas.length === 0
                                                ? <div className="vx-item-list-empty">Nenhuma cidade bloqueada</div>
                                                : this.props.cidadesSelecionadas.map((c, i) => (
                                                    <div key={i} className="vx-item-list-item">
                                                        <div className="vx-item-list-item-info">
                                                            <span className="vx-item-list-item-label">{c.label}</span>
                                                        </div>
                                                        <button type="button" className="vx-item-list-remove"
                                                            onClick={() => this.props.removerCidadeSelecionada(c.value)}>
                                                            <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                                                        </button>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </SectionCard>
                                </div>

                                {/* 8. Motoristas + Bloquear Vendedores */}
                                <div className="vx-config-grid">
                                    <SectionCard icon="drive_eta" title="Motoristas" subtitle="Vincule motoristas a este itinerário">
                                        <Select
                                            ref={this.componentRef}
                                            placeholder='Adicionar motorista...'
                                            styles={SELECT_STYLES}
                                            value={null}
                                            noOptionsMessage={() => 'Nenhuma opção encontrada'}
                                            options={this.props.motoristas
                                                .filter(it => !this.props.motoristasSelecionados.map(m => m.value).includes(it.usuarioEmpresaId))
                                                .map(elemento => ({
                                                    label: elemento.nome,
                                                    value: elemento.usuarioEmpresaId
                                                }))}
                                            onChange={e => this.handleSelecionarMotorista(e)}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                        />
                                        <div className="vx-item-list">
                                            {!this.props.motoristasSelecionados || this.props.motoristasSelecionados.length === 0
                                                ? <div className="vx-item-list-empty">Nenhum motorista vinculado</div>
                                                : this.props.motoristasSelecionados.map((m, i) => (
                                                    <div key={i} className="vx-item-list-item">
                                                        <div className="vx-item-list-item-info">
                                                            <span className="vx-item-list-item-label">{m.label}</span>
                                                        </div>
                                                        <button type="button" className="vx-item-list-remove"
                                                            onClick={() => this.props.removerMotorista(m.value)}>
                                                            <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                                                        </button>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </SectionCard>

                                    <FieldsetBloquearVendedores
                                        usuariosDisponiveis={this.props.usuariosVendedores}
                                        vendedoresSelecionados={this.props.usuarioEmpresaBloqueioSelecionados}
                                        onAdicionar={this.props.selecionarVendedorParaBloquear}
                                        onRemover={this.props.removerUsuarioEmpresaBloqueio}
                                    />
                                </div>

                            </form>
                        </div>

                        {/* ── Footer ── */}
                        <div className="vx-modal-footer">
                            {this.props.idItinerario && (
                                <BotaoAtivarOuInativar
                                    idItinerario={this.props.idItinerario}
                                    idEmpresa={this.props.itinerarioSelecionado.idEmpresa}
                                    ativo={this.props.itinerarioSelecionado.ativo}
                                    ativarItinerario={this.props.ativarItinerario}
                                    inativarItinerario={this.props.inativarItinerario}
                                    buscarItinerarios={this.props.buscarItinerarios}
                                    fecharModal={this.fecharModal} />
                            )}
                            <button type="submit" form="form-cadastrar-itinerario"
                                disabled={invalid || submitting || pristine || this.desabilitarBotaoSalvar()}
                                className="vx-btn-primary">
                                <i className="material-icons" style={{ fontSize: 16 }}>save</i> Salvar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            tipoConfiguracaoPreco: { label: 'Normal', value: 'NORMAL' },
            tipoConfiguracaoPrecoPrioritario: { label: 'Por usuário', value: 'POR_USUARIO' },
            prestador: { label: 'Frota própria', value: '' }
        },
        exibirAjuste: formValueSelector('formularioCadastroItinerario')(state, 'exibirAjuste'),
        exibirAjustePrioritario: formValueSelector('formularioCadastroItinerario')(state, 'exibirAjustePrioritario'),
        descontoMaximo: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'descontoMaximo'),
        tipoConfiguracaoPreco: formValueSelector('formularioCadastroItinerario')(state, 'tipoConfiguracaoPreco'),
        idItinerario: formValueSelector('formularioCadastroItinerario')(state, 'idItinerario'),
        dataPartida: formValueSelector('formularioCadastroItinerario')(state, 'dataPartida'),
        horaPartidaRegra: formValueSelector('formularioCadastroItinerario')(state, 'horaPartidaRegra'),
        quantidadePoltronasRegra: formValueSelector('formularioCadastroItinerario')(state, 'quantidadePoltronasRegra'),
        trechoOrigem: formValueSelector('formularioCadastroItinerario')(state, 'trechoOrigem'),
        trechoDestino: formValueSelector('formularioCadastroItinerario')(state, 'trechoDestino'),
        cidade: formValueSelector('formularioCadastroItinerario')(state, 'cidade'),
        trechoOrigemBloqueioDesconto: formValueSelector('formularioCadastroItinerario')(state, 'trechoOrigemBloqueioDesconto'),
        trechoDestinoBloqueioDesconto: formValueSelector('formularioCadastroItinerario')(state, 'trechoDestinoBloqueioDesconto'),
        veiculo: formValueSelector('formularioCadastroItinerario')(state, 'veiculo'),
        assentosDisponiveis: formValueSelector('formularioCadastroItinerario')(state, 'assentosDisponiveis'),
        prestador: formValueSelector('formularioCadastroItinerario')(state, 'prestador'),
        vendedores: formValueSelector('formularioCadastroItinerario')(state, 'vendedores'),
        valorAjuste: formValueSelector('formularioCadastroItinerario')(state, 'valorAjuste'),
        tipoAjusteItinerario: formValueSelector('formularioCadastroItinerario')(state, 'tipoAjusteItinerario'),
        tipoAjusteItinerarioPrioritario: formValueSelector('formularioCadastroItinerario')(state, 'tipoAjusteItinerarioPrioritario'),
        valorAjustePrioritario: formValueSelector('formularioCadastroItinerario')(state, 'valorAjustePrioritario'),
        tipoConfiguracaoPrecoPrioritario: formValueSelector('formularioCadastroItinerario')(state, 'tipoConfiguracaoPrecoPrioritario'),
        horaPartidaRegraPrioritario: formValueSelector('formularioCadastroItinerario')(state, 'horaPartidaRegraPrioritario'),
        quantidadePoltronasRegraPrioritario: formValueSelector('formularioCadastroItinerario')(state, 'quantidadePoltronasRegraPrioritario'),
        exibirAjustePorCategoria: formValueSelector('formularioCadastroItinerario')(state, 'exibirAjustePorCategoria'),
        tipoAjusteCategoria: formValueSelector('formularioCadastroItinerario')(state, 'tipoAjusteCategoria'),
        valorAjusteCategoria: formValueSelector('formularioCadastroItinerario')(state, 'valorAjusteCategoria'),
        tipoPrecoCategoria: formValueSelector('formularioCadastroItinerario')(state, 'tipoPrecoCategoria'),
        empresaSelecionada: state.empresaSelecionada,
        tiposPreco: state.tiposPreco,
        veiculos: state.veiculos.veiculos,
        itinerarioSelecionado: state.itinerarioSelecionado,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        rotaSelecionada: state.rotaSelecionada,
        motoristas: state.motoristas,
        rotas: state.rotas.rotas,
        prestadoresSimples: state.prestadores.prestadoresSimples,
        trechos: state.trechos,
        veiculoItinerarioSelecionado: state.veiculoItinerarioSelecionado,
        usuariosVendedores: state.usuariosVendedores,
    };
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarItinerario,
        alterarItinerario,
        ativarItinerario,
        inativarItinerario,
        selecionarVeiculoItinerario,
        limparVeiculoItinerarioSelecionado,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroItinerario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalCadastrarItinerario));
